/* ============================================
   NEW HERO CAROUSEL FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const isDesignMode = typeof window.Shopify !== 'undefined' && Boolean(window.Shopify.designMode);
    const TRANSITION_MS = 900;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function syncSlideMedia(slide, shouldPlay) {
        if (!slide) return;

        slide.querySelectorAll('video').forEach((video) => {
            if (shouldPlay) {
                const playPromise = video.play();
                if (playPromise && typeof playPromise.catch === 'function') {
                    playPromise.catch(() => {});
                }
            } else {
                video.pause();
            }
        });
    }

    function setSlideAccessibility(slides, activeIndex) {
        slides.forEach((slide, index) => {
            const isActive = index === activeIndex;
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

            if (isDesignMode) {
                slide.hidden = !isActive;
            }
        });
    }

    function initHero(hero) {
        if (hero.dataset.carouselInitialized === 'true') return;
        hero.dataset.carouselInitialized = 'true';

        const slides = hero.querySelectorAll('.hero__slide');
        const dots = hero.querySelectorAll('.hero__dot');
        const prevButton = hero.querySelector('.hero__arrow--prev');
        const nextButton = hero.querySelector('.hero__arrow--next');
        const slider = hero.querySelector('.hero__slider');

        if (slides.length === 0) return;

        const autoplayEnabled = hero.dataset.autoplay === 'true' && !isDesignMode && !prefersReducedMotion;
        const autoplayDelaySeconds = parseInt(hero.dataset.autoplayDelay, 10);
        const autoplayDelay = Number.isFinite(autoplayDelaySeconds) ? autoplayDelaySeconds * 1000 : 5000;

        initCarousel(hero, slides, dots, prevButton, nextButton, slider, autoplayEnabled, autoplayDelay);
    }

    function initAllHeroes(root) {
        const scope = root || document;
        const heroes = scope.querySelectorAll('[data-hero-carousel]');
        if (heroes.length === 0) return;
        heroes.forEach(initHero);
    }

    initAllHeroes(document);

    document.addEventListener('shopify:section:load', (event) => {
        initAllHeroes(event.target);
    });

    function initCarousel(hero, slides, dots, prevButton, nextButton, slider, autoplayEnabled, autoplayDelay) {
        let currentSlide = 0;
        let autoplayInterval = null;
        let touchStartX = 0;
        let touchEndX = 0;
        let isTransitioning = false;

        const initiallyActive = Array.from(slides).findIndex((slide) => slide.classList.contains('hero__slide--active'));
        if (initiallyActive >= 0) {
            currentSlide = initiallyActive;
        }

        function updateDots(index) {
            dots.forEach((dot, dotIndex) => {
                dot.classList.toggle('hero__dot--active', dotIndex === index);
                dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
            });
        }

        function showSlide(index) {
            if (index === currentSlide || isTransitioning) {
                updateDots(index);
                return;
            }

            const previousSlide = slides[currentSlide];
            const nextSlide = slides[index];
            if (!nextSlide) return;

            isTransitioning = true;

            if (previousSlide) {
                previousSlide.classList.remove('hero__slide--active');
                syncSlideMedia(previousSlide, false);
            }

            nextSlide.classList.add('hero__slide--active');
            syncSlideMedia(nextSlide, true);

            currentSlide = index;
            setSlideAccessibility(slides, index);
            updateDots(index);

            window.setTimeout(() => {
                isTransitioning = false;
            }, prefersReducedMotion ? 0 : TRANSITION_MS);
        }

        function navigateSlide(direction) {
            let newIndex = currentSlide + direction;

            if (newIndex < 0) {
                newIndex = slides.length - 1;
            } else if (newIndex >= slides.length) {
                newIndex = 0;
            }

            goToSlide(newIndex);
        }

        function goToSlide(index) {
            if (index >= 0 && index < slides.length) {
                showSlide(index);
                resetAutoplay();
            }
        }

        function startAutoplay() {
            stopAutoplay();
            if (autoplayEnabled) {
                autoplayInterval = setInterval(() => {
                    navigateSlide(1);
                }, autoplayDelay);
            }
        }

        function stopAutoplay() {
            if (autoplayInterval) {
                clearInterval(autoplayInterval);
                autoplayInterval = null;
            }
        }

        function resetAutoplay() {
            stopAutoplay();
            if (autoplayEnabled) {
                startAutoplay();
            }
        }

        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            const swipeThreshold = 50;
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    navigateSlide(1);
                } else {
                    navigateSlide(-1);
                }
            }
        }

        slides.forEach((slide, index) => {
            const isActive = index === currentSlide;
            slide.classList.toggle('hero__slide--active', isActive);
            syncSlideMedia(slide, isActive);
        });
        setSlideAccessibility(slides, currentSlide);
        updateDots(currentSlide);

        if (prevButton) {
            prevButton.addEventListener('click', () => navigateSlide(-1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => navigateSlide(1));
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => goToSlide(index));
        });

        if (slider) {
            slider.addEventListener('touchstart', handleTouchStart, { passive: true });
            slider.addEventListener('touchend', handleTouchEnd, { passive: true });
        }

        if (autoplayEnabled) {
            startAutoplay();
            hero.addEventListener('mouseenter', stopAutoplay);
            hero.addEventListener('mouseleave', startAutoplay);
        }

        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                slides.forEach((slide) => syncSlideMedia(slide, false));
            } else {
                syncSlideMedia(slides[currentSlide], true);
            }
        });
    }
})();
